import React from 'react';
import StudioContent from './components/StudioContent';
import StudioContextStore from './components/StudioContextStore';
import StudioEditorProvider from './components/StudioEditorProvider';
import { withPageByolWatermark } from 'venn-components';
import { StudioPageLoadingState } from './components/StudioPageLoadingState';
import { StudioErrorBoundary } from './components/StudioErrorBoundary';
import { useHistory } from 'react-router-dom';

const StudioPage = React.memo(function StudioPage() {
  const history = useHistory();
  return (
    <StudioEditorProvider>
      <StudioErrorBoundary history={history}>
        <React.Suspense fallback={<StudioPageLoadingState />}>
          <StudioContextStore>
            <StudioContent />
          </StudioContextStore>
        </React.Suspense>
      </StudioErrorBoundary>
    </StudioEditorProvider>
  );
});

export default withPageByolWatermark(StudioPage);
